import {css} from 'aphrodite';
import React, {useRef} from 'react';
import _ from 'underscore';

import {sharedStyles} from 'processes/settings/fields/ProcessTaskSchemaFieldConstants';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import ErrorMessage from 'ui-library/ErrorMessage';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import InputWrapper from 'ui-library/inputs/InputWrapper';
import Menu from 'ui-library/menus/Menu';
import {MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';
import SettingsField, {SettingsPopover} from 'ui-library/SettingsField';

export const STATUS_LIFECYCLE_FIELD_HELP_TEXT = 'Configure the statuses a task will use in its lifecycle.';

interface ProcessTaskStatusLifecycle {
  id: string;
  name: string;
}

export default function StatusLifecycleField(props: {
  value: ProcessTaskStatusLifecycle;
  isBeingCreated: boolean;
  options: Array<ProcessTaskStatusLifecycle>;
  onChange: (newStatusLifecycle: ProcessTaskStatusLifecycle) => void;
  error?: string | null;
}): JSX.Element {
  const idRef = useRef(_.uniqueId('statusLifecycle'));
  return (
    <>
      {props.isBeingCreated ? (
        <InputWrapper
          id={idRef.current}
          label="Status lifecycle"
          labelStyle={FieldLabel.STYLES.LABEL}
          isRequired={true}
          help={STATUS_LIFECYCLE_FIELD_HELP_TEXT}
        >
          <SelectDropdown
            displayName={props.value.name}
            className={css(sharedStyles.input)}
            menu={
              <Menu value={props.value.id} width={MenuWidth.FULL}>
                {props.options.map((statusLifecycle) => (
                  <Option
                    key={statusLifecycle.id}
                    value={statusLifecycle.id}
                    onSelect={() => {
                      props.onChange(statusLifecycle);
                    }}
                  >
                    {statusLifecycle.name}
                  </Option>
                ))}
              </Menu>
            }
          />
        </InputWrapper>
      ) : (
        <SettingsField
          label="Status lifecycle"
          name="Status lifecycle"
          value={props.value.name}
          isBeingCreated={false}
          isRequired={false}
          isWritable={false}
          onChange={() => {}}
          dataTestAttrs={{component: 'StatusLifecycleField', element: 'root'}}
          helpIcon={
            <SettingsPopover
              renderContent={() => (
                <div className={css(sharedStyles.helpTooltip)}>{STATUS_LIFECYCLE_FIELD_HELP_TEXT}</div>
              )}
            />
          }
        />
      )}
      {props.error != null && <ErrorMessage error={props.error} />}
    </>
  );
}
